import { render, staticRenderFns } from "./DashboardElementsList.vue?vue&type=template&id=04cc6ed9"
import script from "./DashboardElementsList.vue?vue&type=script&lang=js"
export * from "./DashboardElementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports